import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import VideoCameraRegular from './video-camera-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <VideoCameraRegular {...validProps} />;
}

SvgComponent.iconName = 'videoCameraRegular';

export const VideoCameraRegularIcon = svgIconWrapper(SvgComponent);
